import { BaseAccountAdminSettingViewModel } from '../common/base-account-admin-setting-form.viewmodel';
import { AccountAdminSettingEntity } from '../common/account-admin-setting.entity';
import { MessageDescriptor } from 'react-intl';
import { URL_PARAMETER_REGISTRATION_DATA_UPDATED_TEXT } from '../account-admin.text';

class URLParameterRegistrationFormVM extends BaseAccountAdminSettingViewModel {
    constructor(
        protected readonly entity: AccountAdminSettingEntity,
    ) {
        super(entity);
    }

    public get notificationMessage(): MessageDescriptor {
        return URL_PARAMETER_REGISTRATION_DATA_UPDATED_TEXT as MessageDescriptor;
    }

    public async apiCall(): Promise<void> {
        await this.accountAdminDAO.updateURLParameterRegistrationData({
            ...this.entity.getCommonAPIPayload(),
            urlParameterRegistrationEnabled: this.entity.enabled
        });
    }
};

export default URLParameterRegistrationFormVM;
